import { Currency } from '@/core/currency/interfaces';

const BYN: Currency = {
    name: 'Belarusian Ruble',
    demonym: 'Belarusian',
    majorSingle: 'Ruble',
    majorPlural: 'Rubles',
    codeNumeric: '933',
    symbol: 'Br',
    symbolNative: 'руб.',
    minorSingle: 'Kapiejka',
    minorPlural: 'Kapiejka',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BYN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BYN;
